import { LinearProgress } from "@mui/material";

export const Loading = () => {
  return <LinearProgress />;
};
